import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ContainerAcordionCard = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 32px 0;

  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 768px) {
      padding: 0;
  }
`;

export const Acordion = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;

  max-width: ${(props) => props.maxWidthAcordion ? props.maxWidthAcordion : "640px"};

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${(props) => (props.isOpen ? "32px" : "0")};

  border-radius: 16px;
  cursor: ${({hasBlock, hideToggleIcon}) => hasBlock && !hideToggleIcon ? "not-allowed" : "auto"};
  border: ${({ hasError }) => hasError ? `2px solid ${theme.colors.red.Vermelho_erro}` : `2px solid ${theme.colors.gray.Cinza_12}`};
`;

export const AcordionHeader = styled.div`
  width: 100%;
  height: 58px;
  max-width: ${(props) => props.maxWidthAcordionHeader ? props.maxWidthAcordionHeader : "572px"};

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: ${(props) =>
    props.isOpen ? `2px solid ${theme.colors.gray.Cinza_12}` : `none`};

  cursor: ${({hasBlock, hideToggleIcon}) => hasBlock && !hideToggleIcon ? "not-allowed" : "pointer"};

  transition: all 0.3s ease;

  >h6{
    color: ${({hasBlock, hideToggleIcon, titleColor}) => hasBlock && !hideToggleIcon ? theme.colors.gray.Cinza_8 : (titleColor ? titleColor : theme.colors.gray.Cinza_2)};
  }
`;

export const ArrowIcon = styled.img`
  width: 1rem;
  height: 1rem;

  transition: transform 0.3s ease;
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
`;

export const AcordionContent = styled.div`
  width: 100%;
  padding: 4px 0;
  will-change: height;

  overflow: hidden;

  display: ${(props) => (props.$isOpen === false ? "none" : "flex")};
  align-items: flex-start;
  justify-content: center;

  transition: height 0.3s ease, opacity 0.3s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};

  pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};

  @media (max-width: 479px) {
    padding: 4px 0 4px ;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  justify-content: center;
`;
